import React from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { UnderConstruction } from "../../Component/UnderConstruction/UnderConstruction";

export const Support = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t("SUPPORT")} backTo={-1} />
      <Container fluid>
        <Row justify="center" style={{ marginTop: "60px" }}>
          <Col xs={24} sm={20} md={16} lg={12} xl={10}>
            <UnderConstruction />
          </Col>
        </Row>
      </Container>
    </>
  );
};
